// src/App.js
import React, { useState, useEffect } from 'react';
import './App.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import Guest from './navigation/Guest';
import Logged from './navigation/Logged';
import Admin from './navigation/Admin';
import Preloader from './components/Preloader';

import firebaseConfig from './utils/Firebase';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseApp = firebase.initializeApp(firebaseConfig);
firebaseApp.firestore().settings({ experimentalForceLongPolling: true });

const theme = createTheme({
  palette: {
    primary: { main: '#1f93a1' },
    secondary: { main: '#FFBF00' },
  },
});

export default function App() {
  const [isLogged, setIsLogged] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const unsubscribe = firebaseApp.auth().onAuthStateChanged((user) => {
      if (user && user.emailVerified) {
        validateAdmin(user.email);
      } else {
        setIsLogged(false);
        setIsAdmin(false);
        setLoader(true);
      }
    });

    return () => unsubscribe(); // limpieza
  }, []);

  const validateAdmin = async (email) => {
    try {
      const snapshot = await firebase.firestore().collection('admin').get();
      const isAdminUser = snapshot.docs.some(doc => doc.data().email === email);

      setIsAdmin(isAdminUser);
      setIsLogged(!isAdminUser);
    } catch (error) {
      console.error('Error validating admin:', error);
    } finally {
      setLoader(true);
    }
  };

  if (!loader) return <Preloader />;

  return (
    <ThemeProvider theme={theme}>
      {!isLogged && !isAdmin && <Guest />}
      {isLogged && <Logged />}
      {isAdmin && <Admin />}
    </ThemeProvider>
  );
}
